// Registrační seznam agend modulu Reservations — konzumuje ho centrální registr native agend
// (`app/router/nativeAgendaRegistry`) pro globální registraci v kernelu (agendy nemají vlastní route).

import type { AgendaRegistration } from '@/shared/navigation';

import { RESERVATIONS_BUSINESS_CASES } from './permissions';
import { businessCaseListAgenda, BusinessCaseListPage } from './businessCase';

/** Agendy slice Rezervace (route `/reservations`) — seznam obchodních případů jako root. */
export const reservationsAgendas: AgendaRegistration[] = [
  {
    agenda: businessCaseListAgenda,
    component: BusinessCaseListPage,
    permission: RESERVATIONS_BUSINESS_CASES,
  },
];
